import { Converter } from '../types/converter';

export const thermalExpansionConverter: Converter = {
  id: 'thermalExpansion',
  name: 'Thermal Expansion Converter',
  icon: 'Thermometer',
  categories: ['engineering', 'heat'],
  units: [
    // Base unit
    { name: 'Length/Length/Kelvin', symbol: '1/K', factor: 1 },
    
    // Common temperature units
    { name: 'Length/Length/Degree Celsius', symbol: '1/°C', factor: 1 },
    { name: 'Length/Length/Degree Fahrenheit', symbol: '1/°F', factor: 5/9 },
    { name: 'Length/Length/Degree Rankine', symbol: '1/°R', factor: 5/9 },
    { name: 'Length/Length/Degree Reaumur', symbol: '1/°r', factor: 1.25 }
  ]
};
